var _path, _path2, _g, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFxRateLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 39,
    viewBox: "0 0 30 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1474 38.2822L15.0288 35.1574L9.91015 38.2822C9.68988 38.4167 9.41211 38.2519 9.41211 37.9866V18.4824H20.6453V37.9866C20.6453 38.2519 20.3677 38.4167 20.1474 38.2822Z",
    fill: "#F06595"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_62_54485",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 18,
    width: 6,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7734 36.5341L15.0283 35.1576L17.2832 36.5341V18.4824L12.7734 18.4824L12.7734 36.5341H12.7734Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_62_54485)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7734 39.6531H17.2832V16.0811H12.7734V39.6531Z",
    fill: "#E64980"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0263 1.80169L21.5038 5.21166C21.6828 5.62491 22.0485 5.91831 22.4789 5.99405L26.031 6.61894C26.7986 6.75391 27.2837 7.55033 27.0719 8.32778L26.0915 11.9256C25.9728 12.3616 26.0711 12.8302 26.3539 13.1753L28.688 16.0233C29.1925 16.6389 29.0708 17.5725 28.4269 18.0269L25.4475 20.1291C25.0865 20.3836 24.8715 20.8084 24.8745 21.2613L24.8983 25.0002C24.9037 25.8082 24.232 26.4421 23.4574 26.3607L19.8731 25.9835C19.4388 25.9379 19.011 26.1197 18.7327 26.4687L16.4353 29.3488C15.9388 29.9712 15.0316 30.009 14.4887 29.4298L11.9765 26.7497C11.6722 26.4252 11.2318 26.2792 10.8024 26.3608L7.25864 27.0345C6.49266 27.1801 5.77449 26.604 5.7173 25.798L5.45279 22.0693C5.42077 21.6175 5.17383 21.212 4.79434 20.9881L1.66236 19.1402C0.985445 18.7409 0.791977 17.8203 1.24742 17.1649L3.35442 14.1321C3.6097 13.7647 3.67166 13.2892 3.51959 12.8646L2.26496 9.35975C1.99374 8.60235 2.41583 7.76814 3.17064 7.56977L6.66319 6.65195C7.08632 6.54088 7.42828 6.21803 7.57483 5.7912L8.78449 2.2694C9.04587 1.5083 9.88602 1.15074 10.5871 1.50244L13.8309 3.12906C14.2239 3.3262 14.6858 3.30707 15.0624 3.07785L18.1704 1.18699C18.8422 0.77821 19.707 1.06482 20.0263 1.80169Z",
    fill: "url(#paint0_linear_62_54485)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0263 1.80169L21.5038 5.21166C21.6828 5.62491 22.0485 5.91831 22.4789 5.99405L26.031 6.61894C26.7986 6.75391 27.2837 7.55033 27.0719 8.32778L26.0915 11.9256C25.9728 12.3616 26.0711 12.8302 26.3539 13.1753L28.688 16.0233C29.1925 16.6389 29.0708 17.5725 28.4269 18.0269L25.4475 20.1291C25.0865 20.3836 24.8715 20.8084 24.8745 21.2613L24.8983 25.0002C24.9037 25.8082 24.232 26.4421 23.4574 26.3607L19.8731 25.9835C19.4388 25.9379 19.011 26.1197 18.7327 26.4687L16.4353 29.3488C15.9388 29.9712 15.0316 30.009 14.4887 29.4298L11.9765 26.7497C11.6722 26.4252 11.2318 26.2792 10.8024 26.3608L7.25864 27.0345C6.49266 27.1801 5.77449 26.604 5.7173 25.798L5.45279 22.0693C5.42077 21.6175 5.17383 21.212 4.79434 20.9881L1.66236 19.1402C0.985445 18.7409 0.791977 17.8203 1.24742 17.1649L3.35442 14.1321C3.6097 13.7647 3.67166 13.2892 3.51959 12.8646L2.26496 9.35975C1.99374 8.60235 2.41583 7.76814 3.17064 7.56977L6.66319 6.65195C7.08632 6.54088 7.42828 6.21803 7.57483 5.7912L8.78449 2.2694C9.04587 1.5083 9.88602 1.15074 10.5871 1.50244L13.8309 3.12906C14.2239 3.3262 14.6858 3.30707 15.0624 3.07785L18.1704 1.18699C18.8422 0.77821 19.707 1.06482 20.0263 1.80169",
    stroke: "black",
    strokeOpacity: 0.24,
    strokeWidth: 0.659785
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1869 15.4201C23.1869 20.1121 19.5218 23.9156 15.0007 23.9156C10.4796 23.9156 6.81445 20.1121 6.81445 15.4201C6.81445 10.7283 10.4796 6.9248 15.0007 6.9248C19.5218 6.9248 23.1869 10.7283 23.1869 15.4201Z",
    fill: "url(#paint1_linear_62_54485)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.976 18.32L12.1971 19.8174L12.7485 16.6189L10.5176 14.3389L13.6193 13.8948L15.0193 10.9883L16.3848 13.9123L19.481 14.3959L17.2233 16.6473L17.737 19.8527L14.976 18.32Z",
    fill: "#FFEC99"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_62_54485",
    x1: 4.20216,
    y1: 4.62493,
    x2: 23.3934,
    y2: 27.9555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487976,
    stopColor: "#FFE491"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C89B11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_62_54485",
    x1: 8.59642,
    y1: 9.25227,
    x2: 21.1368,
    y2: 22.9297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E89900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345954,
    stopColor: "#FBC254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C58303"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFxRateLogo);
export default __webpack_public_path__ + "static/media/FXRateLogo.8146c938dd3d1ed8bc854bac5a8a20ab.svg";
export { ForwardRef as ReactComponent };